import { Grid } from "@material-ui/core";
import { leadTimeWidgetStyle } from "./style";

const LeadTimeStatisics = ({ lastMonthsData }) => {
    const classes = leadTimeWidgetStyle();


    const data = lastMonthsData.sort((a, b) => a.order - b.order);

    return <Grid container direction="row" spacing={2} className={classes.latestData}>
        {data.map((item, index) => (<>
            {item?.monthLoads?.length > 0 && <Grid item container direction="column" xs={4} className={classes.wrapper} key={index}>
                <div className={classes.latestDataText}>{item.name}</div>
                <Grid container direction="row" spacing={1} justifyContent="space-between">
                    <Grid item className={`${classes.data} ${classes.average}`}>
                        <div className={classes.hours}>{item.averageLeadTime ?? 0} h</div>
                        <div className={classes.name}>Average Lead Time</div>
                    </Grid>
                    <Grid item className={`${classes.data} ${classes.stDev}`}>
                        <div className={classes.hours}>{item.standardDeviation ?? 0} h</div>
                        <div className={classes.name}>Standard Deviation</div>
                    </Grid>
                </Grid>
            </Grid>}
        </>
        ))}

    </Grid>
}
export default LeadTimeStatisics;